<template>
	<div>
		<el-date-picker v-model="row[column.key]" type="date" placeholder="选择日期"></el-date-picker>
	</div>
</template>

<script>
import mixin from '@/components/tableCells/mixin';

export default {
	name: 'datePickerCell',
	mixins: [mixin],
};
</script>

<style scoped></style>
